<div class="canvas-drawing-container">
  <canvas #canvas class="canvas-drawing"></canvas>
  <button type="button" (click)="clear()" class="ir-btn ir-btn--title th-btn-action ir-txt--right">
    <span>{{ 'common.clear' | translate }}</span>
  </button>
</div>
